module.exports = __webpack_public_path__ + "static/img/jd4.256789a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/jd4.jpg
// module id = SPGB
// module chunks = 1